<!-- =========================================================================================
    File Name: ProductListItem.vue
    Description: Item Component - List VIew
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div>
      <vs-progress v-if="loading" indeterminate color="primary"></vs-progress>

      <!--  ROW    -->
      <div v-if="!loading" class="vx-row mb-1" style="max-height: 550px;overflow: scroll;">
        <div class="vx-col  w-full">
          <template
            v-for="(localization, index) in workingLocalizations" :index="index">
            <vs-input
              class="w-full py-2 my-2"
              :key="localization.language_id"
              :label="getLanguageNameAndCode(localization.language_id)"
              v-model="localization.name"
            />
          </template>

        </div>
      </div>

      <div class="vx-row" v-if="isModified">
        <div class="vx-col w-full mb-2">
          <vs-button class="mx-1 w-full" @click="saveChanges">Save Changes</vs-button>
        </div>
      </div>

    </div>


</template>

<script>
  import types from '@/models';
  import jsonHtml from '@/misc/jsonHtmlPrinter'
  import api from '@/http/api';

  export default {
    // mixins: [
    //   ContainerMixin,
    //   ElementMixin
    // ],
    data() {
      return {
        loading: false,
        jsonHtml: jsonHtml,
        showNewRankDialog: false,
        languages: [new types.Language()],
        originalLocalizations: [new types.CompanyRankLocalization()],
        workingLocalizations: [new types.CompanyRankLocalization()],
      }
    },
    props: {
      rank: {
        type: types.CompanyRank(),
        required: true,
        default: () => {
          return new types.CompanyRank()
        }
      },
    },
    watch: {
      // rank: function (newVal, oldVal) {
      //   if (JSON.stringify(newVal.ranks) === JSON.stringify(oldVal.ranks)) return;
      //   this.setRankCopies(newVal.ranks);
      // },
    },
    mounted() {
      this.fetchLanguages();
    },
    computed: {
      isModified() {
        return JSON.stringify(this.workingLocalizations) !== JSON.stringify(this.originalLocalizations);
      }
    },
    methods: {
      async fetchLanguages() {
        this.loading = true;
        this.languages = await api.fetchAllLanguages();
        this.buildWorkingLocalizations()
        this.loading = false;
      },
      getLanguageNameAndCode(id) {
        try {
          const lang = this.languages.filter((l) => l.language_id === id)[0];
          return `${lang.name} (${lang.code}-${lang.country || ''})`;
        } catch (e) {
          return '?';
        }
      },
      getRankLocalization(localizations, languageId) {
        // it is very likely that the rank doesn't have a localization for each language
        const matches = localizations.filter((l) => l.language_id === languageId);
        if (matches.length > 0) {
          return new types.CompanyRankLocalization(matches[0]);
        }
        return new types.CompanyRankLocalization({ language_id: languageId });
      },
      buildWorkingLocalizations() {
        this.workingLocalizations = [];
        this.languages.forEach((lang) => {
          this.workingLocalizations.push(this.getRankLocalization(this.rank.localizations, lang.language_id))
        });
        this.originalLocalizations = JSON.parse(JSON.stringify(this.workingLocalizations));
      },
      async saveChanges() {
        if (!this.isModified) return;
        this.loading = true;

        let localizationsToSave = [];
        this.languages.forEach((lang)=> {
          // only save if the name has changed
          const original = this.getRankLocalization(this.originalLocalizations, lang.language_id);
          const modified = this.getRankLocalization(this.workingLocalizations, lang.language_id);
          if (original.name !== modified.name) {
            localizationsToSave.push(modified);
          }
        });
        // todo: save via api
        let newRank = await api.putCompanyRankLocalizations(this.rank, localizationsToSave);

        this.$emit('rankUpdated', newRank);

        this.loading = false;

      },
      showNotification(success, message) {
        this.$vs.notify({
          title: success ? 'Success' : 'Error',
          text: message ? message : '',
          color: success ? 'success' : 'danger',
          icon: success ? 'check_circle_outline' : 'error'});
      },
    }
  }
</script>

<style lang="css" scoped>
  .fill-row-loading {
    position: absolute;
    top: 50%;
    left: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
  }
</style>
